import React, { useState, useEffect } from "react";
import _ from "lodash";
import { _generateRandomId, _getTranslation } from "../utils/helper";

const TermsCheckbox = (props) => {
  const randomId = _generateRandomId(10);
  const [isChecked, setIsChecked] = useState(props.value);

  useEffect(() => {
    setIsChecked(props.value);
  }, [props.value]);

  return (
    <React.Fragment>
      <div class={`tema-form ${props.class ?? ""}`}>
        <div className="inline-flex">
          <input
            type="checkbox"
            value={isChecked}
            checked={isChecked}
            id={randomId}
            onChange={(e) => {
              setIsChecked(!isChecked);
              props.onChange(!isChecked);
            }}
            className={_.isString(props.error) ? "field-error" : ""}
            disabled={props.disabled}
          />
          <label htmlFor={randomId}></label>
          <label htmlFor={randomId}>
            {props.label ||
              (props.isTermsCheckbox && (
                <React.Fragment>
                  {" "}
                  {_getTranslation(
                    "by_submitting_this_form_you_automatically_comply_to_our"
                  )}{" "}
                  <a
                    className="tema-text--link"
                    target="_blank"
                    href={props?.privacyUrl ?? "#"}
                  >
                    {_getTranslation("privacy_statement")}
                  </a>
                  .
                </React.Fragment>
              ))}
          </label>
        </div>
      </div>
      {_.isString(props.error) && (
        <div className="form-error text-red-500 text-desktopXS mt-2">
          {props.error}
        </div>
      )}
    </React.Fragment>
  );
};

export default TermsCheckbox;
